import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TopflopListBase } from '@zero/instrument-details/feature-instrument-details/base';
import { TopflopListItemComponent } from '../topflop-list-item/topflop-list-item.component';

@Component({
  selector: 'instrument-details-instrument-topflop',
  templateUrl: './topflop-list-web.component.html',
  styleUrls: ['topflop-list-web.component.scss'],
  imports: [TopflopListItemComponent, TranslocoPipe],
})
export class TopflopListWebComponent extends TopflopListBase {}
